// console.log('resources/assets/js/store.js');
/*
|-------------------------------------------------------------------------------
| VUEX store.js
|-------------------------------------------------------------------------------
| Builds the data store from all of the modules for the Roast app.
*/
/*
  Adds the promise polyfill for IE 11
*/
/*
    Imports Vue and Vuex
*/
import Vue from 'vue';
import Vuex from 'vuex';
// import createMultiTabState from 'vuex-multi-tab-state';
import pathify from 'vuex-pathify';

import { corporateGroups } from './modules/corporate_groups.js';
import { customers } from './modules/customers.js';
import { fixedTables } from './modules/fixed.js';
/*
    Imports all of the modules used in the application to build the data store.
*/
import { layout } from './modules/layout.js';
import { playlists } from './modules/playlists.js';
import { projects } from './modules/projects.js';
// import { salesPages } from './modules/sales-page.js';
import { uploadFiles } from './modules/upload_files.js';
import { userStatus } from './modules/user_status.js';
import users from './modules/users.js';

require('es6-promise').polyfill();

/*
    Initializes Vuex on Vue.
*/
Vue.use(Vuex);

/*
  Exports our data store.
*/
const store = new Vuex.Store({
	plugins: [
		pathify.plugin
		// createMultiTabState({
		// statesPaths: [
		// 'layout',
		// 'customers',
		// 'playlists',
		// 'corporateGroups',
		// 'projects',
		// 'fixedTables',
		// 'userStatus',
		// 'uploadFiles',
		// 'users'
		// ]
		// })
	],
	modules: {
		layout,
		customers,
		playlists,
		corporateGroups,
		projects,
		fixedTables,
		userStatus,
		uploadFiles,
		// salesPages,
		users
	}
	// strict: process.env.NODE_ENV !== 'production'
});

export default store;
